import { createSelector } from 'reselect'
export const getAllAccountAddresses = state => state.userReducer.accountAddresses

export const getShipToAddresses = createSelector(getAllAccountAddresses, (lists = []) => {
  return lists.filter(address => !address?.shipToSequence?.hasErrors)
})
export const getBillToAddresses = createSelector(getAllAccountAddresses, (lists = []) => {
  return lists
})
